import { jwtDecode } from 'jwt-decode';

export function getDecodedToken(): any {
    const token = localStorage.getItem('rbac-token');
    if (token) {
      try {
        return jwtDecode(token);
      } catch (error) {
        return null;
      }
    }
    return null;
  }